import { Link } from "react-router-dom";
import MegaMenu from "./MegaMenu";

export default function Navbar() {
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#FDFBF7]/70 border-b border-[#1A1A1A]/10"
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-4 flex flex-col items-center justify-center text-center gap-2.5">
        <Link to="/" data-testid="nav-logo" className="flex flex-col items-center leading-none">
          <span className="font-serif-display text-xl sm:text-3xl font-semibold tracking-[0.08em] sm:tracking-[0.14em] uppercase">Vintage Identity</span>
          <span className="text-[10px] sm:text-xs uppercase tracking-[0.3em] sm:tracking-[0.35em] text-[#8B5A2B] mt-1">Vintage Virtual Try-On</span>
        </Link>

        <Link
          to="/try-on"
          data-testid="nav-cta"
          className="text-xs uppercase tracking-[0.2em] bg-[#1A1A1A] text-[#FDFBF7] px-5 py-2.5 rounded-full hover:bg-[#6D214F] transition-colors duration-300"
        >
          Try It On
        </Link>

        <div className="absolute right-6 md:right-10 top-4">
          <MegaMenu />
        </div>
      </div>
    </header>
  );
}
